<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="itemValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-select class="mb-4" v-if="!duplicating"
                :label="$t('common.type')"
                :placeholder="$t('common.type')"
                label-classes="required"
                v-model="value.type"
                :options="typesNames"
                :templates="typesTemplates"
                @input="errors.clear('type')"
                :error="errors.get('type')"
            >
            </base-select>

            <div class="row mb-2">
                <div class="col-md-6">
                    <base-checkbox class="mb-3" v-model="value.simulation_role_1">
                        {{ degree.simulation_role_1_name[degree.lang] }}
                    </base-checkbox>
                </div>
                <div class="col-md-6">
                    <base-checkbox class="mb-3" v-model="value.simulation_role_2" v-if="degree.simulation_role_2_name">
                        {{ degree.simulation_role_2_name[degree.lang] }}
                    </base-checkbox>
                </div>
            </div>

            <label class="form-control-label">
                {{ $t('common.description') }}
            </label>
            <editor class="mb-3" v-model="value.description" :height="250"></editor>

            <base-select class="mb-4"
                :label="$t('common.competencies')"
                :placeholder="$t('common.competencies')"
                v-model="value.competency_ids"
                :options="competencies"
                @input="errors.clear('competencies')"
                :error="errors.get('competencies')"
                color="info"
                :multiple="true"
            >
            </base-select>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },
            
            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                required: true
            },
            
            degree: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('itemValidator', this)
        },

        computed: {

            typesNames() {
                let names = {}
                for (let id in this.types) {
                    let type = this.types[id]
                    names[id] = type.name.en
                }
                return names
            },

            typesTemplates() {
                let templates = {}
                for (let id in this.types) {
                    let type = this.types[id]
                    templates[id] = '<i class="' + type.icon + ' text-' + type.color + ' mr-2"></i>' + type.name.en
                }
                return templates
            }
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
